import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { Injectable } from '@angular/core';

/**
 * Overrides the Angular URL serializer to prevent it from encoded the folder paths
 * Old: production%2FmaleAdult%2Fheart_v02
 * New: production/maleAdult/heart_v02
 */
@Injectable()
export class CustomUrlSerializer implements UrlSerializer {
  parse(url: any): UrlTree {
    // Implemented on November 25, 2019
    // Some published have implemented iframes using `&amp;` instead of `&`
    url = url.replace(/&amp;/g, '&');

    const defaultSerializer = new DefaultUrlSerializer();
    const tree = defaultSerializer.parse(url);

    // Implemented on November 19th, 2019
    // Some publishers have implemented broken iframe sources that worked with classic widget
    // but broke with the Angular 8 upgrade.
    // This ensure that the core URL parameters are always retrieved, even if the URL Serializer gives up.
    this.ensureQueryParam(tree.queryParams, 'dk', url);
    this.ensureQueryParam(tree.queryParams, 'uaid', url);

    return tree;
  }

  serialize(tree: UrlTree): any {
    const defaultSerializer = new DefaultUrlSerializer();
    const path = defaultSerializer.serialize(tree);

    // Replace encoded folder params with originals
    return path.replace(/%2F/g, '/');
  }

  private ensureQueryParam(queryParams, paramName, url) {
    // Param already exists, do nothing
    if (queryParams.hasOwnProperty(paramName)) {
      return queryParams;
    }

    // Get param from unparsed URL, if available
    const param = this.getParameterByName(paramName, url);
    if (param !== null) {
      queryParams[paramName] = param;
    }
    return queryParams;
  }

  private getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
      return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
